import React, { memo } from 'react'
import { Grid } from '@mui/material'

import FAQs from './FAQs'
import ClaimCards from './ClaimCards'
import ConnectWalletForClaim from './ConnectWalletForClaim'
import Text from '../shared/text/Text'
import DefaultText from '../shared/text/DefaultText'
import Staking from './Staking'
import Staking2 from './Staking2'
import Wallet from './Wallet'
import StakingBanner from '../stakingBanner/StakingBanner'

const CommunitySale = ({
  t,
  isWalletConnected,
  onClickClaim,
  mainProfile,
  claimActionProps,
  claimStakeProps,
  address
}) => {
  return (
    <Grid container spacing={3} pt={0} pb={3}>
      <Grid item xs={12}>
        <Grid container spacing={2} alignItems='center'>
          <Grid item xs={12}>
            <Grid container spacing={2} alignItems='center'>
              <Grid item xs={12} sm={9} md={9}>
                <Text
                  variant='h2'
                  label={t('home.welcome-text')}
                  color='text.primary'
                  fontWeight={700}
                />
                <DefaultText
                  label={t('home.welcome-desc')}
                  color='text.primary'
                  sx={{ fontSize: 18 }}
                />
              </Grid>
              <Grid item xs={12} sm={3} md={3}>
                <Wallet t={t} address={address} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <StakingBanner t={t} />
      </Grid>
      <Grid item xs={12} position='relative'>
        {isWalletConnected && mainProfile.contractsForClaim.length ? (
          <Grid container spacing={3}>
            {mainProfile.claimStake.available > 0 && (
              <Grid item xs={12}>
                <Staking t={t} mainProfile={mainProfile} {...claimStakeProps} />
              </Grid>
            )}
            {mainProfile.claimStake2.available > 0 && (
              <Grid item xs={12}>
                <Staking2
                  t={t}
                  mainProfile={mainProfile}
                  {...claimStakeProps}
                />
              </Grid>
            )}
            <ClaimCards
              t={t}
              onClickClaim={onClickClaim}
              claimActionProps={claimActionProps}
              mainProfile={mainProfile}
            />
          </Grid>
        ) : (
          <ConnectWalletForClaim t={t} isWalletConnected={isWalletConnected} />
        )}
      </Grid>
      <Grid item xs={12}>
        <FAQs t={t} />
      </Grid>
    </Grid>
  )
}

export default memo(CommunitySale)
